module.exports = __webpack_public_path__ + "img/puptitle1.158e56d5.png";